import React, { useState } from 'react';
import styles from './pmndp-enhanced.module.css';
import AddPatentsModel from "./Add-Patients-model";
import SlotManagementModal from "./SloatManagement";
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { Tooltip } from '@mui/material';

// Mock data - move to external file or API in production
const MOCK_TABLE_DATA = [
    { srNo: '1', patientName: 'Aakash', age: '24', mobileNo: '9255110080', abhaNumber: 'NA', abhaAddress: 'NA', healthId: 'NA', mode: 'HD', dialysisSupportType: 'PMJAY', procedureType: 'Negative', gender: 'Male', action: { view: true, download: true, edit: true, delete: true } },
    { srNo: '2', patientName: 'Aakash', age: '24', mobileNo: '9255110080', abhaNumber: 'NA', abhaAddress: 'NA', healthId: 'NA', mode: 'HD', dialysisSupportType: 'PMJAY', procedureType: 'Negative', gender: 'Male', action: { view: true, download: true, edit: true, delete: true } },
    { srNo: '3', patientName: 'Aakash', age: '24', mobileNo: '9255110080', abhaNumber: 'NA', abhaAddress: 'NA', healthId: 'NA', mode: 'HD', dialysisSupportType: 'PMJAY', procedureType: 'Negative', gender: 'Male', action: { view: true, download: true, edit: true, delete: true } },
    { srNo: '4', patientName: 'Aakash', age: '24', mobileNo: '9255110080', abhaNumber: 'NA', abhaAddress: 'NA', healthId: 'NA', mode: 'HD', dialysisSupportType: 'PMJAY', procedureType: 'Negative', gender: 'Male', action: { view: true, download: true, edit: true, delete: true } },
    { srNo: '5', patientName: 'Aakash', age: '24', mobileNo: '9255110080', abhaNumber: 'NA', abhaAddress: 'NA', healthId: 'NA', mode: 'HD', dialysisSupportType: 'PMJAY', procedureType: 'Negative', gender: 'Male', action: { view: true, download: true, edit: true, delete: true } },
    { srNo: '6', patientName: 'Aakash', age: '24', mobileNo: '9255110080', abhaNumber: 'NA', abhaAddress: 'NA', healthId: 'NA', mode: 'HD', dialysisSupportType: 'PMJAY', procedureType: 'Negative', gender: 'Male', action: { view: true, download: true, edit: true, delete: true } },
    { srNo: '7', patientName: 'Aakash', age: '24', mobileNo: '9255110080', abhaNumber: 'NA', abhaAddress: 'NA', healthId: 'NA', mode: 'HD', dialysisSupportType: 'PMJAY', procedureType: 'Negative', gender: 'Male', action: { view: true, download: true, edit: true, delete: true } },
    { srNo: '8', patientName: 'Aakash', age: '24', mobileNo: '9255110080', abhaNumber: 'NA', abhaAddress: 'NA', healthId: 'NA', mode: 'HD', dialysisSupportType: 'PMJAY', procedureType: 'Negative', gender: 'Male', action: { view: true, download: true, edit: true, delete: true } },
    { srNo: '9', patientName: 'Aakash', age: '24', mobileNo: '9255110080', abhaNumber: 'NA', abhaAddress: 'NA', healthId: 'NA', mode: 'HD', dialysisSupportType: 'PMJAY', procedureType: 'Negative', gender: 'Male', action: { view: true, download: true, edit: true, delete: true } },
    { srNo: '10', patientName: 'Aakash', age: '24', mobileNo: '9255110080', abhaNumber: 'NA', abhaAddress: 'NA', healthId: 'NA', mode: 'HD', dialysisSupportType: 'PMJAY', procedureType: 'Negative', gender: 'Male', action: { view: true, download: true, edit: true, delete: true } },
];

const PMNDPTableProgram = () => {
    const [showModal, setShowModal] = useState(false);
    const [showSlots, setShowSlots] = useState(false);

    const handleCloseSlots = () => {
        setShowSlots(false);
    };

    return (
        <>
            <section className="patientDetails">

                <div className="patientTableFilterSection">
                    <div className="patientDetailsTitleHeader-h d-flex">
                        <span><img src={"/images/PMNDP-logo.png"} alt="" className='pnmdp_icon' /></span>
                        <h4>New Patient List</h4>

                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-md-2">
                            <div className="feilds">
                                <label>ABHA Number:</label>
                                <input type="text" placeholder="ABHA Number:" />
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-2">
                            <div className="feilds">
                                <label>ABHA Address :</label>
                                <input type="text" placeholder="ABHA Address :" />
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-2">
                            <div className="feilds">
                                <label>Health ID:</label>
                                <input type="text" placeholder="Health ID:" />
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-2">
                            <div className="feilds">
                                <label>Patient Name :</label>
                                <input type="text" placeholder="Patient Name :" />
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-2">
                            <div className="feilds">
                                <label>Mobile :</label>
                                <input type="text" placeholder="Mobile :" />
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-2">
                            <div className="feilds">
                                <label>&nbsp;</label>
                                <button className='search'>Search</button>
                                <button className='reset'>Reset</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pmndpTable">
                    <div className="table-responsive rounded">
                        <table className='table table-bordered custom-striped table-hover'>
                            <thead>
                                <tr>
                                    <th>S.No.</th>
                                    <th>Patient Name</th>
                                    <th>Age</th>
                                    <th>Mobile No.</th>
                                    <th>ABHA number</th>
                                    <th>ABHA Address</th>
                                    <th>Health ID</th>
                                    <th>Mode</th>
                                    <th>Dialysis Support Type</th>
                                    <th>Procedure Type</th>
                                    <th>Gender</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {MOCK_TABLE_DATA.map((item) => (
                                    <tr key={item.srNo}>
                                            <td>{item.srNo}</td>
                                            <td>{item.patientName}</td>
                                            <td>{item.age}</td>
                                            <td>{item.mobileNo}</td>
                                            <td>{item.abhaNumber}</td>
                                            <td>{item.abhaAddress}</td>
                                            <td>{item.healthId}</td>
                                            <td>{item.mode}</td>
                                            <td>{item.dialysisSupportType}</td>
                                            <td>{item.procedureType}</td>
                                            <td>{item.gender}</td>
                                            <td>
                                                <div className="actionBtn">
                                                    {item.action.view && (
                                                        <Tooltip title="View" arrow>
                                                            <button className="btn btn-primary btn-sm me-2">
                                                                <VisibilityIcon fontSize="small" />
                                                            </button>
                                                        </Tooltip>
                                                    )}

                                                    {item.action.edit && (
                                                        <Tooltip title="Edit" arrow>
                                                            <button className="btn btn-success btn-sm me-2">
                                                                <EditIcon fontSize="small" />
                                                            </button>
                                                        </Tooltip>
                                                    )}

                                                    {item.action.delete && (
                                                        <Tooltip title="Delete" arrow>
                                                            <button className="btn btn-danger btn-sm me-2">
                                                                <DeleteIcon fontSize="small" />
                                                            </button>
                                                        </Tooltip>
                                                    )}

                                                    {item.action.download && (
                                                        <Tooltip title="Upload" arrow>
                                                            <button className="btn btn-secondary btn-sm me-2">
                                                                <UploadFileIcon fontSize="small" />
                                                            </button>
                                                        </Tooltip>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

            </section>

            {showModal && (
                <AddPatentsModel onClose={() => setShowModal(false)} />
            )}

            {showSlots && (
                <SlotManagementModal onClose={handleCloseSlots} />
            )}
        </>
    )
}

export default PMNDPTableProgram;
